import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { selectCdrById } from "src/store/callrecorder/cdrsSlice";
import { fetchCdr } from "src/actions/callrecorder/cdrsActions";

import PageLayout from "../_partials/PageLayout";
import SummaryShow from "src/componets/SummaryShow";
import SidebarShow from "./_partials/_SidebarShow";
import Icon from "src/componets/Icon";

const Show: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const record = useAppSelector(state => id ? selectCdrById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchCdr(id));
    }
  }, [id, dispatch]);

  const formatDuration = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return m > 0 ? `${m}m ${s}s` : `${s}s`;
  };

  return (
    <PageLayout className='v-cdrs-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            record &&
              <SummaryShow
                icon={<Icon icon="fa-solid fa-phone-volume" />}
                title={`CDR #${id}`}
                subtitle={`${record.src || '?'} → ${record.dst || '?'} — ${record.disposition || 'unknown'} (${formatDuration(record.duration)})`}
                createdAt={record.calldate || record.start_call || ''}
                updatedAt={record.end_call || record.calldate || ''}
                dateName1='Call Date'
                dateName2='End Call'
                className='v-mb-15'
              />
          }
        </div>
      </div>

      <SidebarShow record={record} />
    </PageLayout>
  )
}

export default Show;
